import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge55 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='メンバーフィーとは' fontWeight={700} />
                <p>
                    メンバーフィーとは、ゴルフ場の会員が実際にラウンドする当日に支払う、1回あたりのプレー料金のことです。会員は非会員（ビジター）よりも割安な料金でプレーできるのが一般的で、会員権を持つメリットの一つです。
                    <br />
                    本記事では、メンバーフィーの意味や、ビジターフィー・年会費・預託金との違いについて整理します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ビジターフィー・年会費・預託金との違い' fontWeight={700} />

                <Heading3 title='ビジターフィーとの違い' />
                <p>
                    メンバーフィーの対になる言葉が、非会員がプレーする際に支払う「ビジターフィー」です。同じゴルフ場でも、会員が支払うメンバーフィーのほうが、ビジターフィーよりも低く設定されているのが一般的です。
                </p>

                <Heading3 title='年会費との違い' />
                <p>
                    メンバーフィーは、プレーした回数に応じて都度支払う費用（変動費）です。一方、
                    <a href='/knowledge/11'>年会費</a>
                    は、プレーの有無にかかわらず会員権を維持するために毎年支払う費用（固定費）です。支払うタイミングも性質も異なるため、混同しないよう注意しましょう。
                </p>

                <Heading3 title='預託金との違い' />
                <p>
                    <a href='/knowledge/4'>預託金</a>
                    は、入会時に一度預け入れ、退会時に返還を受ける性質のお金です。プレーのたびに支払うメンバーフィーとは、発生するタイミングも性質も異なります。なお、預託金の返還条件（据置期間や返還の有無など）はゴルフ場によって異なるため、詳細は各ゴルフ場にご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='メンバーフィーに含まれる費用の範囲' fontWeight={700} />
                <p>
                    ロッカー代や施設利用料、練習場の利用料などが、メンバーフィーに含まれるのか、別途精算になるのかは、ゴルフ場によって異なります。実際にプレーする際にいくらかかるのかは、金額だけでなく内訳まで確認しておくと安心です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    メンバーフィーは、会員がプレーする当日に支払う1回あたりの料金で、年会費や預託金とは別の費用です。ゴルフ場によって含まれる費用の範囲が異なる場合があるため、会員権の購入や維持費を検討する際は、実際に何がいくら請求されるのかを個別に確認することが大切です。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge55;
